/**
 * @generated SignedSource<<33296a8a2c180661503be462cf46c5ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useAuthModalQuery$variables = {};
export type useAuthModalQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useAuthModalFragment">;
};
export type useAuthModalQuery = {
  response: useAuthModalQuery$data;
  variables: useAuthModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useAuthModalQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "useAuthModalFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useAuthModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GalleryUser",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Wallet",
                    "kind": "LinkedField",
                    "name": "wallets",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ChainAddress",
                        "kind": "LinkedField",
                        "name": "chainAddress",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "address",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "chain",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v0/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "dbid",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Viewer",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "61b7431b6b235f713752b486cc99d643",
    "id": null,
    "metadata": {},
    "name": "useAuthModalQuery",
    "operationKind": "query",
    "text": "query useAuthModalQuery {\n  ...useAuthModalFragment\n}\n\nfragment AddWalletPendingDefaultFragment on Query {\n  viewer {\n    __typename\n    ... on Viewer {\n      user {\n        wallets {\n          chainAddress {\n            address\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n  ...ManageWalletsModalFragment\n}\n\nfragment AddWalletPendingFragment on Query {\n  ...AddWalletPendingGnosisSafeFragment\n  ...AddWalletPendingDefaultFragment\n}\n\nfragment AddWalletPendingGnosisSafeFragment on Query {\n  viewer {\n    __typename\n    ... on Viewer {\n      user {\n        wallets {\n          chainAddress {\n            address\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n  ...ManageWalletsModalFragment\n}\n\nfragment DeprecatedWalletSelectorFragment on Query {\n  ...AddWalletPendingFragment\n}\n\nfragment EthereumAddWalletFragment on Query {\n  viewer {\n    __typename\n    ... on Viewer {\n      user {\n        wallets {\n          chainAddress {\n            address\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n  ...ManageWalletsModalFragment\n}\n\nfragment GnosisSafeAddWalletFragment on Query {\n  viewer {\n    __typename\n    ... on Viewer {\n      user {\n        wallets {\n          chainAddress {\n            address\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n  ...ManageWalletsModalFragment\n}\n\nfragment ManageWalletsFragment on Query {\n  viewer {\n    __typename\n    ... on Viewer {\n      user {\n        wallets {\n          dbid\n          chainAddress {\n            address\n            chain\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment ManageWalletsModalFragment on Query {\n  ...ManageWalletsFragment\n}\n\nfragment MultichainWalletSelectorFragment on Query {\n  ...EthereumAddWalletFragment\n  ...GnosisSafeAddWalletFragment\n  ...TezosAddWalletFragment\n}\n\nfragment TezosAddWalletFragment on Query {\n  viewer {\n    __typename\n    ... on Viewer {\n      user {\n        wallets {\n          chainAddress {\n            address\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n  ...ManageWalletsModalFragment\n}\n\nfragment WalletSelectorFragment on Query {\n  ...DeprecatedWalletSelectorFragment\n  ...MultichainWalletSelectorFragment\n}\n\nfragment useAuthModalFragment on Query {\n  viewer {\n    __typename\n    ... on Viewer {\n      user {\n        id\n      }\n    }\n  }\n  ...WalletSelectorFragment\n}\n"
  }
};
})();

(node as any).hash = "986bf86d2b7e0fd9d1c262ea43c1f341";

export default node;
